import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Form,
  Input,
  Radio,
  Select,
  Typography,
  Space,
  Table,
  notification,
  Modal,
} from 'antd';
import jsonSpanish from '../../../lang/es/politicas.json';
import jsonEnglish from '../../../lang/en/policies.json';
import Paragraph from "antd/es/typography/Paragraph";

import { get as getPolicy, patch as patchPolicy, post as postPolicy } from '../../../api/modules/answerPolicies';
import { post as postActors, getAllByPolicy, remove as removeActor } from '../../../api/modules/answerPolicyActors';
import { post as postResource, getAllByPolicy as getAllByPolicyResources, remove as removeResource } from '../../../api/modules/answerPolicyResources';

import LoadingModal from '../../../components/LoadingModal';

import INTERNAL_LINKS from '../../../enum/InternalLinks';
import FORM_MESSAGES from '../../../enum/FormMessages';

const { Title } = Typography;

const PollPolicies = ({ history, match }) => {
  const [form] = Form.useForm();
  const [formActors] = Form.useForm();
  const [formResources] = Form.useForm();
  const [lang] = useState(match.params.lang);
  const [fileLang, setFileLang] = useState(jsonEnglish);
  const [loading, setLoading] = useState(false);
  const [loadingActor, setLoadingActor] = useState(false);
  const [loadingResource, setLoadingResource] = useState(false);
  const [actorsData, setActorsData] = useState(false);
  const [actorsVisible, setActorsVisible] = useState(false);
  const [resourcesData, setResourcesData] = useState(false);
  const [resourcesVisible, setResourcesVisible] = useState(false);
  const Q17AnswersOptions = {
    en: ["Very low", "Low", "Medium", "High", "Very high", "Not apply"],
    es: ["Muy baja", "Baja", "Media", "Alta", "Muy alta", "No aplica"]
  };
  const [q16f, setQ16F] = useState(false);

  const QActorsTypeOptions = {
    es: [
      "Actor nacional municipal",
      "Actor nacional provincial",
      "Cooperación internacional",
      "Agencia de desarrollo",
      "Organizaciones de la sociedad civil"
    ],
    en: [
      "National municipal actor",
      "Provincial municipal actor",
      "International cooperation",
      "Development agency",
      "Civil society organizations"
    ]
  }

  const actorsColumns = [
    {
      title: "#",
      dataIndex: "id",
      key: "id"
    },
    {
      title: lang === 'en' ? "Name" : "Nombre",
      dataIndex: "name",
      key: "name"
    },
    {
      title: lang === 'en' ? "Type" : "Tipo",
      dataIndex: "actor_type",
      key: "actor_type",
      render: (text, record) => {
        return QActorsTypeOptions[lang][record.actor_type];
      }
    },
    {
      title: lang === 'en' ? "Actions" : "Acciones",
      dataIndex: "id",
      key: "id",
      render: (text, record) => {
        return (<Button type="primary" onClick={() => { deleteActor(record.id); }}>{lang === "en" ? "Remove" : "Eliminar"}</Button>);
      }
    }
  ]
  const resourcesColumns = [
    {
      title: "#",
      dataIndex: "id",
      key: "id"
    },
    {
      title: lang === 'en' ? "Type of resource" : "Tipo de recurso",
      dataIndex: "resource_type",
      key: "resource_type"
    },
    {
      title: lang === 'en' ? "Actors involved" : "Actores involucrados",
      dataIndex: "actor_type",
      key: "actor_type"
    },
    {
      title: lang === 'en' ? "Actions" : "Acciones",
      dataIndex: "id",
      key: "id",
      render: (text, record) => {
        return (<Button type="primary" onClick={() => { deleteResource(record.id); }}>{lang === "en" ? "Remove" : "Eliminar"}</Button>);
      }
    }
  ];
  useEffect(() => {
    if (match.params.id) {
      load();
    }

    if (lang === 'en') {
      setFileLang(jsonEnglish);
    } else if (lang === 'es') {
      setFileLang(jsonSpanish);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const load = async () => {
    await Promise.all([
      getAnswerPolicy(),
      getActors(),
      getResources(),
    ]);
  };

  const handleQ16F = (value) => {
    value = parseInt(value);

    if (value === 1) {
      setQ16F(true);
    } else {
      setQ16F(false);
    }
  };

  const getAnswerPolicy = async () => {
    let response = await getPolicy(match.params.id);
    form.setFieldsValue(response.data);
    handleQ16F(response.data.q16_f);
  };

  const getActors = async () => {
    let response = await getAllByPolicy(match.params.id);
    setActorsData(response.data.results);
  };

  const getResources = async () => {
    let response = await getAllByPolicyResources(match.params.id);
    setResourcesData(response.data.results);
  };

  const save = async (data) => {
    setLoading(true);
    let response;
    try {
      if (match.params.id) {
        response = await patchPolicy(match.params.id, data);
      } else {
        data["answer"] = match.params.answer_id;
        response = await postPolicy(data);
      }
      notification.open({
        message: 'Successful transaction / Transacción exitosa ',
        duration: 2,
        placement: "bottomRight"
      });
      setLoading(false);
      history.push(`${INTERNAL_LINKS.POLL_POLICIES}/${match.params.answer_id}/${lang}/${response.data.id}`);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const saveActor = async (data) => {
    setLoadingActor(true);
    try {
      data["answer"] = match.params.answer_id;
      data["politic"] = match.params.id;
      await postActors(data);
      formActors.resetFields();
      getActors();
      notification.open({
        message: 'Successful transaction / Transacción exitosa ',
        duration: 2,
        placement: "bottomRight"
      });
      setLoadingActor(false);
      setActorsVisible(false);
    } catch (err) {
      console.log(err);
      setLoadingActor(false);
    }
  };

  const saveResource = async (data) => {
    setLoadingResource(true);
    try {
      data["answer"] = match.params.answer_id;
      data["politic"] = match.params.id;
      await postResource(data);
      formResources.resetFields();
      getResources();
      notification.open({
        message: 'Successful transaction / Transacción exitosa ',
        duration: 2,
        placement: "bottomRight"
      });
      setLoadingResource(false);
      setResourcesVisible(false);
    } catch (err) {
      console.log(err);
      setLoadingResource(false);
    }
  };

  const deleteActor = async (id) => {
    setLoadingActor(true);
    try {
      await removeActor(id);
      getActors();
      notification.open({
        message: 'Successful transaction / Transacción exitosa ',
        duration: 2,
        placement: "bottomRight"
      });
      setLoadingActor(false);
    } catch (err) {
      console.log(err);
      setLoadingActor(false);
    }
  };

  const deleteResource = async (id) => {
    setLoadingResource(true);
    try {
      await removeResource(id);
      getResources();
      notification.open({
        message: 'Successful transaction / Transacción exitosa ',
        duration: 2,
        placement: "bottomRight"
      });
      setLoadingResource(false);
    } catch (err) {
      console.log(err);
      setLoadingResource(false);
    }
  };

  return (<div>
    {
      lang === 'en' ?
        <>
          <Title level={3}>PART V: DEVELOPMENT OF PUBLIC POLICIES AND GOOD PRACTICES</Title>
          <Paragraph>Can you choose one or two public policies (programs, projects or initiatives) issues that are already being implemented in your locality and that in your opinion are the most relevant or you consider important to in the attention to migrants or refugees.</Paragraph>
        </>
        :
        <>
          <Title level={3}>PARTE V: DESARROLLO DE POLÍTICAS PÚBLICAS Y BUENAS PRÁCTICAS</Title>
          <Paragraph>Por favor elija uno o dos políticas públicas (programas, proyectos o iniciativas) que ya se estén implementando en su localidad y que en su opinión sean las más relevantes o considere importantes para la atención a los migrantes o refugiados.</Paragraph>
        </>
    }

    <Form
      form={form}
      layout="vertical"
      onFinish={(data) => {
        save(data);
      }}
      validateMessages={FORM_MESSAGES[`validateMessages${lang.toUpperCase()}`]}
      scrollToFirstError={true}
    >
      <Form.Item
        label={`16. ${fileLang.q16.text}`}
        name="q16"
      >
        <Form.Item
          label={`${fileLang.q16.a.text}`}
          name="q16_a"
        >
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item
          label={`${fileLang.q16.b.text}`}
          name="q16_b"
        >
          <Select
            optionFilterProp="children"
            mode="multiple"
          >
            {
              fileLang.q16.b.options.map(item => { return (<Select.Option key={`option-q16b-key-${item.value}`} value={item.value}>{item.text}</Select.Option>); })
            }
          </Select>
        </Form.Item>
        <Form.Item
          label={`${fileLang.q16.c.text}`}
          name="q16_c"
        >
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item
          label={`${fileLang.q16.d.text}`}
          name="q16_d"
        >
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item
          label={`${fileLang.q16.e.text}`}
          name="q16_e"
        >
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item
          onChange={(event) => { handleQ16F(event.target.value); }}
          label={`${fileLang.q16.f.text}`}
          name="q16_f"
        >
          <Radio.Group>
            {
              fileLang.q16.f.options.map(item => { return (<Radio key={`radio-q16-f-key-${item.value}`} value={item.value}>{item.text}</Radio>); })
            }
          </Radio.Group>
        </Form.Item>
        {q16f === true &&
        <Form.Item
            label={`${fileLang.q16.f.otherText}`}
            name="q16_f_other"
        >
          <Input.TextArea rows={4} />
        </Form.Item>
        }
        <Form.Item
          label={`${fileLang.q16.g.text}`}
          name="q16_g"
        >
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item
          label={`${fileLang.q16.h.text}`}
          name="q16_h"
        >
          <Radio.Group>
            {
              fileLang.q16.h.options.map(item => { return (<Radio key={`radio-q16-h-key-${item.value}`} value={item.value}>{item.text}</Radio>); })
            }
          </Radio.Group>
        </Form.Item>
        <Form.Item>
          <Button loading={loading} type="primary" htmlType="submit">{lang === 'en' ? 'Save and continue' : 'Guardar y continuar'}</Button>
        </Form.Item>
        <Form.Item
          label={`${fileLang.q16.i.text}`}
        >
          {
            match.params.id &&
            <Button type="primary" onClick={() => { setActorsVisible(true); }}>{lang === 'en' ? "Add" : "Agregar"}</Button>
          }
          <br></br>
          <br></br>
          <Table loading={loadingActor} columns={actorsColumns} dataSource={actorsData}></Table>
        </Form.Item>
        <Form.Item
          label={`${fileLang.q16.j.text}`}
        >
          {
            match.params.id &&
            <Button type="primary" onClick={() => { setResourcesVisible(true); }}>{lang === 'en' ? "Add" : "Agregar"}</Button>
          }
          <br></br>
          <br></br>
          <Table loading={loadingResource} columns={resourcesColumns} dataSource={resourcesData}></Table>
        </Form.Item>
        <Form.Item
          label={`${fileLang.q16.k.text}`}
          name="q16_k"
        >
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item
          label={`${fileLang.q16.l.text}`}
          name="q16_l"
        >
          <Radio.Group>
            {
              fileLang.q16.l.options.map(item => { return (<Radio key={`radio-q16-l-key-${item.value}`} value={item.value}>{item.text}</Radio>); })
            }
          </Radio.Group>
        </Form.Item>
        <Form.Item
          label={`${fileLang.q16.m.text}`}
          name="q16_m"
        >
          <Select>
            {
              fileLang.q16.m.options.map(item => { return (<Select.Option key={`option-q16m-key-${item.value}`} value={item.value}>{item.text}</Select.Option>); })
            }
          </Select>
        </Form.Item>
      </Form.Item>
      <Form.Item
        label={`17.`}
        name="q17"
      >
        <Form.Item
          label={`${fileLang.q17.a.text}`}
          name="q17_a"
        >
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item
          label={`${fileLang.q17.b.text}`}
        >
          <Table columns={[
            {
              title: fileLang.q17.b.headerColumn0,
              dataIndex: 'text',
              key: 'text',
            },
            {
              title: fileLang.q17.b.headerColumn1,
              dataIndex: 'value',
              key: 'value',
              render: (text, record) => {
                return (
                  <Form.Item
                    name={`q17_b_${text}`}
                  >
                    <Radio.Group>
                      <Radio value={0}>{Q17AnswersOptions[lang][0]}</Radio>
                      <Radio value={1}>{Q17AnswersOptions[lang][1]}</Radio>
                      <Radio value={2}>{Q17AnswersOptions[lang][2]}</Radio>
                      <Radio value={3}>{Q17AnswersOptions[lang][3]}</Radio>
                      <Radio value={4}>{Q17AnswersOptions[lang][4]}</Radio>
                      <Radio value={99}>{Q17AnswersOptions[lang][5]}</Radio>
                    </Radio.Group>
                  </Form.Item>
                );
              }
            },
          ]} dataSource={[
            { value: "1", text: fileLang.q17.b.headerOption1 },
            { value: "2", text: fileLang.q17.b.headerOption2 },
            { value: "3", text: fileLang.q17.b.headerOption3 },
            { value: "4", text: fileLang.q17.b.headerOption4 },
          ]}></Table>
        </Form.Item>
      </Form.Item>
      <Form.Item
        label={`18.`}
        name="q18"
      >
        <Form.Item
          label={`${fileLang.q18.a.text}`}
          name="q18_a"
        >
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item
          label={`${fileLang.q18.b.text}`}
          name="q18_b"
        >
          <Input.TextArea rows={4} />
        </Form.Item>
      </Form.Item>
      <Form.Item>
        <Space>
          <Button loading={loading} type="primary" htmlType="submit">{lang === 'en' ? 'Save and continue' : 'Guardar y continuar'}</Button>
          <Button type="link"><Link to={`${INTERNAL_LINKS.POLL_CHAPTER_V}/${match.params.answer_id}/${lang}/`}>{lang === 'en' ? 'Back' : 'Volver'}</Link></Button>
        </Space>
      </Form.Item>
    </Form>
    <Modal
      title={lang === 'en' ? "Actors Form" : "Formulario de Actores"}
      centered
      visible={actorsVisible}
      onCancel={() => setActorsVisible(false)}
      footer={null}
    >
      <Form
        form={formActors}
        layout="vertical"
        onFinish={(data) => {
          saveActor(data);
        }}
      >
        <Form.Item
          label={lang === "en" ? "Name" : "Nombre"}
          name="name"
        >
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item
          label={lang === "en" ? "Type" : "Tipo"}
          name="actor_type"
        >
          <Select>
            <Select.Option value={0}>{QActorsTypeOptions[lang][0]}</Select.Option>
            <Select.Option value={1}>{QActorsTypeOptions[lang][1]}</Select.Option>
            <Select.Option value={2}>{QActorsTypeOptions[lang][2]}</Select.Option>
            <Select.Option value={3}>{QActorsTypeOptions[lang][3]}</Select.Option>
            <Select.Option value={4}>{QActorsTypeOptions[lang][4]}</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item>
          <Space>
            <Button loading={loadingActor} type="primary" htmlType="submit">{lang === 'en' ? 'Save' : 'Guardar'}</Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
    <Modal
      title={lang === 'en' ? "Resources Form" : "Formulario de Recursos"}
      centered
      visible={resourcesVisible}
      onCancel={() => setResourcesVisible(false)}
      footer={null}
    >
      <Form
        form={formResources}
        layout="vertical"
        onFinish={(data) => {
          saveResource(data);
        }}
      >
        <Form.Item
          label={lang === "en" ? "Type of resource" : "Tipo de recurso"}
          name="resource_type"
        >
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item
          label={lang === "en" ? "Actors involved" : "Actores involucrados"}
          name="actor_name"
        >
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item>
          <Space>
            <Button loading={loadingActor} type="primary" htmlType="submit">{lang === 'en' ? 'Save' : 'Guardar'}</Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
    <LoadingModal loading={loading} lang={lang}></LoadingModal>
  </div>);
};

export default PollPolicies;